module.exports = __webpack_public_path__ + "static/media/circle-check2.e7032102.svg";